 
import {CookieService} from 'ngx-cookie-service';

import * as de from '@angular/common/locales/de';
import { CommonModule, registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/blocks/allgemein/footer/footer.component';
import { HeaderComponent } from './components/blocks/allgemein/header/header.component'; 
import { BetriebComponent } from './components/blocks/tabs/betrieb/betrieb.component';
import { WinddatenGebietskategorieComponent } from './components/blocks/tabs/winddaten-gebietskategorie/winddaten-gebietskategorie.component';
import { MatSpinnerOverlayComponent } from './components/elemente/mat-spinner-overlay/mat-spinner-overlay.component';
import { ErgebnisseComponent } from './components/pages/anwendung/ergebnisse/ergebnisse.component';
import { MainComponent } from './components/pages/anwendung/main/main.component';
import { ModalAuswahlQuelleComponent } from './components/pages/anwendung/modal/modal-auswahl-quelle/modal-auswahl-quelle.component';
import { ModalSchnelleinstellungenComponent } from './components/pages/anwendung/modal/modal-schnelleinstellungen/modal-schnelleinstellungen.component';
import { PageNotFoundComponent } from './components/pages/page-not-found/page-not-found.component';
import { MaterialModule } from './material/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HilfeComponent } from './components/pages/navbar-pages/hilfe/hilfe.component';
import { ModalWindrichtungWertAnzeigenComponent } from './components/pages/anwendung/modal/modal-windrichtung-wert-anzeigen/modal-windrichtung-wert-anzeigen.component'; 
import { KoordinatenHilfeDialogComponent } from './components/elemente/koordinaten-hilfe-dialog/koordinaten-hilfe-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent, 
    FooterComponent,
    PageNotFoundComponent,
    MainComponent,
    MatSpinnerOverlayComponent,
    ErgebnisseComponent,
    ModalAuswahlQuelleComponent,
    ModalSchnelleinstellungenComponent,
    BetriebComponent,
    WinddatenGebietskategorieComponent,
    HilfeComponent,
    ModalWindrichtungWertAnzeigenComponent,
    KoordinatenHilfeDialogComponent
  ],
  imports: [
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    ReactiveFormsModule, 
  ],
  providers: [
    CookieService, { provide: LOCALE_ID, useValue: 'de-DE' } // Verwende 'de-DE' für deutsche Locale-Einstellungen
],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    registerLocaleData(de.default); // Registriere die deutsche Locale
  }
}